"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useHorizontalScroll = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("react");
var _globalConstants = require("../global-constants");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SET_SCROLL_STATE = 'SET_SCROLL_STATE';
var initialState = {
  canScrollLeft: false,
  canScrollRight: false,
  hasOverflow: false
};
function scrollReducer(state, action) {
  switch (action.type) {
    case SET_SCROLL_STATE:
      return _objectSpread(_objectSpread({}, state), action.payload);
    default:
      return state;
  }
}
var useHorizontalScroll = exports.useHorizontalScroll = function useHorizontalScroll() {
  var scrollAmount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _globalConstants.SCROLL_AMOUNTS.monthTab;
  var scrollRef = (0, _react.useRef)(null);
  var [state, dispatch] = (0, _react.useReducer)(scrollReducer, initialState);
  var {
    canScrollLeft,
    canScrollRight,
    hasOverflow
  } = state;
  var checkScrollButtons = (0, _react.useCallback)(() => {
    var el = scrollRef.current;
    if (!el) return;
    var {
      scrollLeft,
      scrollWidth,
      clientWidth
    } = el;
    dispatch({
      type: SET_SCROLL_STATE,
      payload: {
        canScrollLeft: scrollLeft > 0,
        canScrollRight: scrollLeft < scrollWidth - clientWidth,
        hasOverflow: scrollWidth > clientWidth
      }
    });
  }, []);
  (0, _react.useEffect)(() => {
    var el = scrollRef.current;
    if (!el) return;
    checkScrollButtons();
    var handleResize = () => checkScrollButtons();
    var handleScroll = () => checkScrollButtons();
    el.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      el.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [checkScrollButtons]);
  var scrollToLeft = (0, _react.useCallback)(() => {
    var _scrollRef$current;
    (_scrollRef$current = scrollRef.current) === null || _scrollRef$current === void 0 || _scrollRef$current.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  }, [scrollAmount]);
  var scrollToRight = (0, _react.useCallback)(() => {
    var _scrollRef$current2;
    (_scrollRef$current2 = scrollRef.current) === null || _scrollRef$current2 === void 0 || _scrollRef$current2.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  }, [scrollAmount]);
  return {
    scrollRef,
    scrollToLeft,
    scrollToRight,
    canScrollLeft,
    canScrollRight,
    hasOverflow,
    checkScrollButtons
  };
};